/**
 * Runs `fn` after the browser has painted the current UI state (two nested
 * animation frames: the first fires just before the next paint, the second
 * just after it).
 *
 * Used to sequence overlay-close → navigate. Chrome's predictive back
 * gesture captures its screenshot of the outgoing page the moment the
 * history entry changes, so navigating in the same tick as closing a menu
 * or drawer bakes the still-open overlay into that screenshot — it then
 * flashes over the page when the user later swipes back to it. Closing the
 * overlay with a zero-duration transition, letting a frame paint, and only
 * then navigating keeps the screenshot clean. The added delay is ~2 frames.
 */
export const afterPaint = (fn: () => void): void => {
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
};
